import type { EscalationRouting } from '../../hooks/useClientCareConfig';

export interface EscalationCandidateForUi {
  uid: string;
  role: string;
  officeIds: string[];
  canSeeAllOffices: boolean;
  eligibleForEscalation: boolean;
}

export function escalationScopeLabel(candidate: EscalationCandidateForUi): string {
  if (candidate.role === 'super_admin' || candidate.canSeeAllOffices) return 'All offices';
  if (candidate.officeIds.length === 1) return '1 assigned office';
  if (candidate.officeIds.length > 1) return `${candidate.officeIds.length} assigned offices`;
  return 'No office coverage';
}

export function escalationSelectionIsInvalid(
  routing: EscalationRouting,
  candidates: ReadonlyArray<EscalationCandidateForUi>,
): boolean {
  if (routing.mode === 'role_based') return false;
  if (routing.recipientUids.length === 0) return true;
  const byUid = new Map(candidates.map((candidate) => [candidate.uid, candidate]));
  return routing.recipientUids.some((uid) => byUid.get(uid)?.eligibleForEscalation !== true);
}
